<template>
    <div>
        <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shadow">
            <ListingTable :columnCount="columnLength() || 8" :pageLoading="pageLoading" :rowData="rows">
                <template v-slot:thead>
                    <thead>
                        <tr>
                            <template v-for="cols in theadData">
                                <th v-if="cols.visible" :key="cols.id" class="simple-table-th" :class="{
                                    'checkbox-width-limit': cols.checkbox,
                                    'pointer-events-none': lodash.isEmpty(rows),
                                }">
                                    <template v-if="cols.checkbox && Number(cols.checkbox) == 1">
                                        <v-checkbox dense :disabled="pageLoading" color="cyan" class="hide-margin"
                                            hide-details></v-checkbox>
                                    </template>
                                    <template v-else>
                                        <div v-if="cols.sortable" class="simple-table-text sortable" v-on:click="
                                            !pageLoading
                                                ? updateSorting({
                                                    field: cols.field,
                                                    sort: cols.sort,
                                                })
                                                : 'javascript:void(0)'
                                            ">
                                            {{ cols.headerName }}
                                        </div>
                                        <div v-else class="simple-table-text">
                                            {{ cols.headerName }}
                                        </div>

                                        <template v-if="cols.sort">
                                            <v-icon class="simple-table-sort" v-if="cols.sort == 'asc'" small right
                                                color="cyan">mdi-sort-ascending</v-icon>
                                            <v-icon class="simple-table-sort" v-if="cols.sort == 'desc'" small right
                                                color="cyan">mdi-sort-descending</v-icon>
                                        </template>
                                    </template>
                                </th>
                            </template>
                        </tr>
                    </thead>
                </template>
                <template v-slot:tbody>
                    <tbody class="custom-border-bottom">
                        <template v-if="pageLoading">
                            <tr>
                                <td></td>
                                <td></td>
                                <td colspan="3" align="center">
                                    <p class="font-size-20 font-weight-600 my-4">
                                        Please wait...
                                    </p>
                                    <v-progress-linear color="cyan" indeterminate rounded
                                        height="6"></v-progress-linear>
                                    <br />
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                        </template>
                        <template v-if="!lodash.isEmpty(rows)">
                            <tr v-for="(row, index) in rows" :key="index" link class="customer-listing-row" v-on:click="
                                $router.push(
                                    getDefaultRoute(detailRoute, {
                                        params: { id: row.visit_id },
                                    })
                                )
                                ">
                                <template v-for="cols in theadData">
                                    <td v-if="cols.visible" :key="cols.id" class="font-size-18 font-weight-500" :class="{
                                        'simple-table-td': !cols.checkbox,
                                        'checkbox-width-limit': cols.checkbox,
                                    }">
                                        <template v-if="cols.checkbox && Number(cols.checkbox) == 1">
                                            <v-checkbox dense v-model="selectedRows" v-bind:value="Number(row.id)"
                                                color="cyan" class="hide-margin" hide-details></v-checkbox>
                                        </template>
                                        <template v-else-if="cols.field == 'related_id'">
                                            <template v-if="
                                                row.quotation_barcode ||
                                                row.enquiries_barcode ||
                                                row.invoice_barcode
                                            ">
                                                <div class="mt-0 mb-1">
                                                    <v-chip small v-if="row.quotation_barcode"
                                                        class="text-white p-3 cursor-pointer mt-1 clickable-link"
                                                        color="cyan" label outlined v-on:click.prevent.stop="
                                                            routeToDetailLink(
                                                                row.quotation_id,
                                                                'admin.quotation.detail'
                                                            )
                                                            ">
                                                        {{ row.quotation_barcode }}
                                                    </v-chip>
                                                </div>
                                                <div class="my-0">
                                                    <v-chip small v-if="row.enquiries_barcode"
                                                        class="text-white p-3 cursor-pointer mt-1 clickable-link"
                                                        color="orange" label outlined v-on:click.prevent.stop="
                                                            routeToDetailLink(
                                                                row.enquiries_id,
                                                                'admin.enquiry.detail'
                                                            )
                                                            ">
                                                        {{ row.enquiries_barcode }}
                                                    </v-chip>
                                                </div>
                                                <div class="my-0">
                                                    <v-chip small v-if="row.invoice_barcode"
                                                        class="text-white p-3 cursor-pointer mt-1 clickable-link"
                                                        color="green" label outlined v-on:click.prevent.stop="
                                                            routeToDetailLink(
                                                                row.invoice_id,
                                                                'admin.invoice.detail'
                                                            )
                                                            ">
                                                        {{ row.invoice_barcode }}
                                                    </v-chip>
                                                </div>
                                            </template>
                                            <template v-else-if="
                                                row.auto_sales_parent_visit_id && row.parentautovisit
                                            ">
                                                <div class="my-0">
                                                    <v-chip small
                                                        class="font-weight-600 custom-blue-border text-uppercase justify-center my-0 font-10 mr-1"
                                                        color="red" label outlined v-on:click.prevent.stop="
                                                            routeToDetailLink(
                                                                row.auto_sales_parent_visit_id,
                                                                'admin.visit.detail'
                                                            )
                                                            ">
                                                        {{ row.parentautovisit.barcode }}
                                                    </v-chip>
                                                </div>
                                            </template>
                                            <template v-else> --</template>
                                        </template>
                                        <template v-else-if="cols.field == 'barcode'">
                                            <div class="d-flex mb-1">
                                                <v-chip label dense small color="chip-custom-blue" outlined
                                                    class="font-weight-600 custom-barcode">
                                                    <template v-if="row.visit_trips_count > 0">{{ row.visit_barcode
                                                        }}-{{
                                                            row.visit_trips_count
                                                        }}</template>
                                                    <template v-else>{{ row.visit_barcode }}-01</template>
                                                </v-chip>
                                            </div>

                                            <div class="my-0">
                                                <v-chip small
                                                    class="font-weight-600 custom-blue-border text-uppercase justify-center my-0 font-10"
                                                    color="chip-custom-blue" label outlined>
                                                    <template v-if="row.ticket_job_type_text == 'One-Off Job'">
                                                        Adhoc job</template>
                                                    <template v-else>
                                                        {{ row.ticket_job_type_text }}</template>
                                                </v-chip>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'visit_title'">
                                            <div class="job-listing-customer">
                                                <p class="m-0 custom-nowrap-ellipsis-two-line" style="width: 200px">
                                                    {{ row.visit_title }}
                                                </p>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'job_type'">
                                            <div class="job-listing-customer">
                                                <p class="m-0 custom-nowrap-ellipsis-two-line" style="width: 200px">
                                                    {{ formatJobType(row.ticket_type) }}
                                                </p>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'auto_job_type'">
                                            <div class="job-listing-customer">
                                                <p class="m-0 custom-nowrap-ellipsis-two-line" style="width: 150px" v-if="
                                                    row.auto_ticket_type &&
                                                    row.auto_ticket_type.length > 0
                                                ">
                                                    {{ formatJobType(row.auto_ticket_type) }}
                                                </p>
                                                <template v-else>
                                                    <em class="text-muted">no auto job type</em>
                                                </template>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'property'">
                                            <div class="job-listing-customer">
                                                <p class="m-0 custom-nowrap-ellipsis-two-line" v-if="row.property_address" style="width: 300px">
                                                    <span content="Site Location" class="d-flex" v-tippy="{
                                                        arrow: true,
                                                        arrowType: 'round',
                                                        animation: 'fade',
                                                    }">
                                                        <b>
                                                            <v-icon style="font-size: 18px; margin-top: -3px">
                                                                mdi-home-map-marker
                                                            </v-icon>
                                                        </b>
                                                        <template v-if="row?.property_name">{{ row?.property_name }},</template>
                                                        <template v-if="row?.property_unit_no">{{ row?.property_unit_no }},</template>
                                                        <template v-if="row?.property_street_1">{{ row?.property_street_1 }},</template>
                                                        {{ row?.property_street_2 }}

                                                        {{ row?.property_country }}
                                                        <template v-if="
                                                            row?.property_zip_code &&
                                                            row?.property_zip_code != '000000'
                                                        ">
                                                            {{ row?.property_zip_code }}
                                                        </template>
                                                    </span>
                                                </p>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'customer_company'">
                                            <div class="job-listing-customer">
                                                <p class="m-0">
                                                    <v-chip label small color="green white--text" class="d-inline mx-2"
                                                        v-if="row.is_property_tenant">Tenant</v-chip>
                                                </p>
                                                <p class="m-0">
                                                    <span class="m-0 text-truncate" content="Company Name" v-tippy="{
                                                        arrow: true,
                                                        arrowType: 'round',
                                                        animation: 'fade',
                                                    }">
                                                        <b>
                                                            <v-icon style="font-size: 16px">
                                                                mdi-bag-checked
                                                            </v-icon>
                                                        </b>
                                                        {{ row.customer_company_name }}
                                                    </span>
                                                </p>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'customer'">
                                            <div class="job-listing-customer">
                                                <p class="m-0">
                                                    <span class="m-0 text-truncate" content="Site Location Contact Person Email" v-tippy="{
                                                        arrow: true,
                                                        arrowType: 'round',
                                                        animation: 'fade',
                                                    }">
                                                        <b>
                                                            <v-icon style="font-size: 16px">
                                                                mdi-email
                                                            </v-icon>
                                                        </b>
                                                        <template v-if="row && row.property_primary_email">
                                                            {{ row.property_primary_email }}
                                                        </template>
                                                        <template v-else>
                                                            <em class="text-muted"> no email</em>
                                                        </template>
                                                    </span>
                                                </p>
                                                <p class="m-0">
                                                    <span class="m-0 text-truncate" content="Site Location Contact Person Phone" v-tippy="{
                                                        arrow: true,
                                                        arrowType: 'round',
                                                        animation: 'fade',
                                                    }">
                                                        <b>
                                                            <v-icon style="font-size: 16px">
                                                                mdi-phone
                                                            </v-icon>
                                                        </b>
                                                        <template v-if="row && row.property_primary_phone">
                                                            {{ row.property_primary_phone }}
                                                        </template>
                                                        <template v-else>
                                                            <em class="text-muted"> no phone</em>
                                                        </template>
                                                    </span>
                                                </p>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'tags'">
                                            <div style="width: 200px">
                                                <template v-if="row.tags && row.tags.length">
                                                    <template v-for="(data, index) in row.tags">
                                                        <v-chip :key="index" v-if="index < 3" style="height: 18px" class="mr-2 mb-1" text-color="white"
                                                            :color="data.color">{{ data.tag }}</v-chip>
                                                    </template>
                                                    <template v-if="row.tags.length > 3">
                                                        <v-chip small color="blue white--text" label class="ml-2">
                                                            <span class="font-size-16 font-weight-500">
                                                                +{{ row.tags.length - 3 }} More</span>
                                                        </v-chip>
                                                    </template>
                                                </template>
                                                <em v-else class="text-muted"> no tag</em>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'entity'">
                                            <div style="
                                                                  width: 230px;
                                                                  white-space: normal;
                                                                  word-break: break-word;
                                                                ">
                                                <template v-if="row.visit_entity">
                                                    <span class="font-size-18 font-weight-500">
                                                        {{ row.visit_entity }}
                                                    </span>
                                                </template>

                                                <em v-else class="text-muted">no entity</em>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'started_at'">
                                            <p class="m-0 max-content-width text-truncate">
                                                <span class="d-block">
                                                    {{ formatDate(row.visit_started_at) }}
                                                    {{ formatDateTimeStart(row.visit_started_at) }}
                                                    <br />
                                                    {{ formatDate(row.visit_finished_at) }}
                                                    {{ formatDateTimeStart(row.visit_finished_at) }}
                                                </span>
                                                <span v-if="!isDeleted" class="d-block">
                                                    <v-chip class="mt-0 mb-0 font-weight-600 cursor-pointer text-lowercase" color="chip-custom-blue" small
                                                        outlined label>
                                                        <template v-if="row.visit_status === 4">
                                                            completed in {{ row.visit_duration_human }}
                                                        </template>
                                                        <template v-else-if="row.visit_status === 2">
                                                            in-progress
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="row.visit_overdue === 1">delayed by
                                                                {{
                                                                    calculateTotalDuration(row.visit_started_at)
                                                                }}</template>
                                                            <template v-else-if="row.visit_today === 1">ends in
                                                                {{
                                                                    calculateTotalDuration(row.visit_finished_at)
                                                                }}</template>
                                                            <template v-else>starts in
                                                                {{
                                                                    calculateTotalDuration(row.visit_started_at)
                                                                }}</template>
                                                        </template>
                                                    </v-chip>
                                                </span>
                                            </p>
                                        </template>
                                        <template v-else-if="cols.field == 'actual_start_date'">
                                            <div class="m-0 max-content-width text-truncate" v-if="row.actual_start_date || row.actual_end_date">
                                                <p class="m-0">
                                                    <span class="m-0 text-truncate" content="Actual Start Date" v-tippy="{
                                                        arrow: true,
                                                        arrowType: 'round',
                                                        animation: 'fade',
                                                    }">
                                                        <b> Started At : </b>
                                                        <template v-if="row && row.actual_start_date">
                                                            <v-chip small outlined color="red" label>
                                                                {{ formatDate(row.actual_start_date) }}
                                                                {{ formatDateStartTime(row.actual_start_date) }}
                                                            </v-chip>
                                                        </template>
                                                        <template v-else>
                                                            <em class="text-muted"> no started at</em>
                                                        </template>
                                                    </span>
                                                </p>
                                                <p class="m-0">
                                                    <span class="m-0 text-truncate" content="Actual End Date" v-tippy="{
                                                        arrow: true,
                                                        arrowType: 'round',
                                                        animation: 'fade',
                                                    }">
                                                        <b> Ended At &nbsp;&nbsp;: </b>
                                                        <template v-if="row && row.actual_end_date">
                                                            <v-chip small outlined color="green" label>
                                                                {{ formatDate(row.actual_end_date) }}
                                                                {{ formatDateStartTime(row.actual_end_date) }}
                                                            </v-chip>
                                                        </template>
                                                        <template v-else>
                                                            <em class="text-muted"> no ended at</em>
                                                        </template>
                                                    </span>
                                                </p>
                                                <v-chip v-if="
                                                    row &&
                                                    row.actual_end_date &&
                                                    row.actual_start_date &&
                                                    calculateActualTotalDuration(row)
                                                " class="mt-2 mb-2 font-weight-600 cursor-pointer text-lowercase" color="chip-custom-blue"
                                                    small outlined label>
                                                    Total time {{ calculateActualTotalDuration(row) }}
                                                </v-chip>
                                            </div>
                                            <em v-else class="text-muted"> no actual date / time</em>
                                        </template>
                                        <template v-else-if="cols.field == 'status'">
                                            <div>
                                                <v-chip class="mx-2 mb-1 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                                                    :color="getStatusColor(row.visit_status)" label small :text-color="row.visit_status == 2 ? 'black' : 'white'
                                                        ">
                                                    {{ row.visit_status_text }}
                                                </v-chip>
                                            </div>
                                            <div class="d-flex align-center">
                                                <Priority small :priority="priortyInteger(row.ticket_priority)" />

                                                <v-chip v-if="row.is_fully_closed == '1'" class="mb-1 text-uppercase justify-center font-12" outlined
                                                    color="#6A1B9A" label small>
                                                    Closed
                                                </v-chip>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'visit_flag'">
                                            <div class="property-listing-customer">
                                                <p class="m-1 mb-1 custom-nowrap-ellipsis-count">
                                                    <b>
                                                        <v-icon :color="row.is_service_form == 1 ? 'green' : 'red'
                                                            " size="20">mdi-form-select</v-icon>
                                                    </b>
                                                    <template v-if="row?.serviceFrom?.length > 0">
                                                        <v-badge :color="row.is_service_form == 1 ? 'green' : 'red'
                                                            " class="mr-9 ml-5" style="margin-bottom: -2px !important"
                                                            :content="row?.serviceFrom?.length">
                                                        </v-badge>
                                                    </template>
                                                    <template v-else>
                                                        <v-badge :color="row.is_service_form == 1 ? 'green' : 'red'
                                                            " content="0" class="mr-9 ml-5" style="margin-bottom: -2px !important">
                                                        </v-badge>
                                                    </template>
                                                </p>
                                            </div>
                                            <div class="property-listing-customer">
                                                <p class="m-1 mb-1 custom-nowrap-ellipsis-count">
                                                    <b>
                                                        <v-icon :disabled="row && row.is_voice_note ? false : true
                                                            " color="green">mdi-play-circle</v-icon>
                                                    </b>
                                                    <template v-if="row?.audio_count > 0">
                                                        <v-badge :color="row.is_voice_note ? 'green' : '#9e978a'" class="mr-9 ml-4"
                                                            style="margin-bottom: -2px !important" :content="row?.audio_count">
                                                        </v-badge>
                                                    </template>
                                                    <template v-else>
                                                        <v-badge :color="row.is_voice_note ? 'green' : '#9e978a'" content="0" class="mr-9 ml-4"
                                                            style="margin-bottom: -2px !important" :disabled="row && row.is_voice_note ? false : true
                                                                ">
                                                        </v-badge>
                                                    </template>
                                                </p>
                                            </div>

                                            <template v-if="row.follow_ups_data == 1">
                                                <div class="">
                                                    <v-chip small label outlined class="mx-2 d-inline justify-center font-10" text-color="" color="green">
                                                        Follow Up Open
                                                    </v-chip>
                                                </div>
                                            </template>
                                            <template v-if="row.follow_ups_data == 2">
                                                <div class="my-1">
                                                    <v-chip small label outlined class="mx-2 d-inline justify-center font-10" text-color="" color="red">
                                                        Follow Up Closed
                                                    </v-chip>
                                                </div>
                                            </template>
                                            <div v-if="row.visit_reschedule_count > 0" class="my-0">
                                                <v-chip small class="font-weight-600 custom-blue-border text-uppercase justify-center my-0 font-10"
                                                    color="red lighten-1" label outlined>
                                                    Revision ({{ row.visit_reschedule_count }})
                                                </v-chip>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'engineers'">
                                            <div class="job-listing-customer">
                                                <p class="m-0 max-content-width text-truncate font-weight-700 text-capitalize" :class="{
                                                    'text--secondary': lodash.isEmpty(
                                                        row.visit_engineers
                                                    ),
                                                }">
                                                    {{ engineerDisplayText(row.visit_engineers) }}
                                                </p>
                                            </div>
                                            <v-chip v-if="
                                                row.is_rejeced == 1 &&
                                                row.visit_engineers &&
                                                row.visit_engineers.length == 0
                                            " label color="red" outlined text-color="" class="p-3 mr-5 mb-1" small>Re-assignment Pending
                                            </v-chip>
                                            <div>
                                                <v-chip v-if="
                                                    row.visit_engineers &&
                                                    row.visit_engineers.length > 0
                                                " label color="orange" class="p-3 mr-5" text-color="white" small>Assign</v-chip>
                                                <v-chip v-if="
                                                    row.visit_engineers &&
                                                    row.visit_engineers.length == 0
                                                " label color="#24326d" class="p-3 mr-5" text-color="white" small>Unassign</v-chip>
                                            </div>
                                            <div class="" v-if="
                                                row?.enroute == 1 &&
                                                (row.visit_status == 2 || row.visit_status == 3)
                                            ">
                                                <v-chip v-if="row?.enroute" small label class="d-inline justify-center font-10 mt-2" text-color="white"
                                                    color="#2a806b">
                                                    Enroute
                                                </v-chip>
                                            </div>
                                        </template>
                                        <template v-else-if="cols.field == 'visit_added_at'">
                                            <v-chip v-if="row.added_by_display_name" class="mx-2 my-1 custom-grey-border" color="cyan darken-1" small label
                                                text-color="white">
                                                <p class="m-0 custom-nowrap-ellipsis text-capitalize">
                                                    {{ row.added_by_display_name }}
                                                </p>
                                            </v-chip>
                                            <TableActivity v-if="!lodash.isEmpty(row.added_by_display_name)" :data="row">
                                                <template v-slot:date_time>
                                                    <template v-if="getDateCountAll(row.added_at)">{{
                                                        row.created_at
                                                    }}</template>
                                                    <template v-else>{{
                                                        formatDateTime(row.added_at)
                                                    }}</template>
                                                </template>
                                                <template v-slot:format_date_time>
                                                    {{ formatDate(row.added_at) }}
                                                    {{ formatTime(row.added_at) }}
                                                </template>
                                            </TableActivity>
                                        </template>
                                    </td>
                                </template>
                            </tr>
                        </template>
                        <tr v-else-if="!pageLoading">
                            <td :colspan="theadData.length" class="py-4">
                                <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                                    <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                                    Uhh... There are no visit at the moment.
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </ListingTable>
        </perfect-scrollbar>
    </div>
</template>

<script>
import moment from "moment-timezone";
import CommonMixin from "@/core/plugins/common-mixin";
import Priority from "@/view/pages/partials/Priority.vue";
import { toSafeInteger } from "lodash";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
    name: "visit-listing-template",
    mixins: [CommonMixin],

    props: {
        theadData: {
            type: Array,
            required: true,
            default: () => [],
        },
        rows: {
            type: Array,
            required: true,
            default: () => [],
        },
        detailRoute: {
            type: String,
            default: null,
        },
        detailType: {
            type: String,
            default: null,
        },
        isDeleted: {
            type: Boolean,
            default: false,
        },
        internal: {
            type: Boolean,
            default: false,
        },
        pageLoading: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        detailRoute() {
            this.$emit("success", true);
        },
    },
    components: {
        TableActivity,
        Priority,
        ListingTable,
    },
    data() {
        return {
            selectedRows: [],
        };
    },
    methods: {
        formatJobType(value) {
            if (!value) return "";

            const formatText = (text) => {
                return text
                    .replace(/[-_]/g, " ")
                    .replace(/\b\w/g, (c) => c.toUpperCase());
            };

            if (Array.isArray(value)) {
                return value.map(formatText).join(", ");
            }

            return formatText(value);
        },
        columnLength() {
            const defaultColDefs = this.lodash.filter(this.theadData, {
                visible: true,
            });
            if (defaultColDefs) {
                return defaultColDefs.length;
            }
            return 0;
        },
        formatDateStartTime(row) {
            return moment(row).format("hh:mm A");
        },

        priortyInteger(param) {
            return toSafeInteger(param);
        },
        formatDateTimeStart(row) {
            return moment(row).format("hh:mm A");
        },
        routeToDetailLink(id, type) {
            this.$router.push({
                name: type,
                params: { id },
            });
        },

        getStatusColor(status) {
            if (status == 1) {
                return "blue darken-1";
            }
            if (status == 2) {
                return "yellow darken-1";
            }
            if (status == 3) {
                return "orange darken-4";
            }
            if (status == 4) {
                return "green darken-1";
            }
            if (status == 5) {
                return "red lighten-1";
            }
            if (status == 6) {
                return "orange darken-4";
            }
            return null;
        },
        calculateTotalDuration(visit_date) {
            if (moment(visit_date).isValid()) {
                let a = moment(visit_date);
                let b = moment();

                let totalDuration = moment.duration(a.diff(b));
                if (b.isAfter(a)) {
                    totalDuration = moment.duration(b.diff(a));
                }

                let result = [];

                let years = totalDuration.get("years");
                if (years > 0) {
                    if (years == 1) {
                        result.push(years + " Year");
                    } else {
                        result.push(years + " Years");
                    }
                }

                let months = totalDuration.get("months");
                if (months > 0) {
                    if (months == 1) {
                        result.push(months + " Month");
                    } else {
                        result.push(months + " Months");
                    }
                }

                let days = totalDuration.get("days");
                if (days > 0) {
                    if (days == 1) {
                        result.push(days + " Day");
                    } else {
                        result.push(days + " Days");
                    }
                }

                let hours = totalDuration.get("hours");
                if (hours > 0) {
                    if (hours == 1) {
                        result.push(hours + " Hour");
                    } else {
                        result.push(hours + " Hours");
                    }
                }

                let minutes = totalDuration.get("minutes");
                if (minutes > 0) {
                    if (minutes == 1) {
                        result.push(minutes + " Minute");
                    } else {
                        result.push(minutes + " Minutes");
                    }
                }

                return result.join(" ");
            }
        },
        calculateActualTotalDuration(row) {
            if (moment(row.actual_start_date).isValid()) {
                let a = moment(row.actual_start_date);
                let b = moment(row.actual_end_date);

                let totalDuration = moment.duration(a.diff(b));
                if (b.isAfter(a)) {
                    totalDuration = moment.duration(b.diff(a));
                }

                let result = [];

                let years = totalDuration.get("years");
                if (years > 0) {
                    if (years == 1) {
                        result.push(years + " Year");
                    } else {
                        result.push(years + " Years");
                    }
                }

                let months = totalDuration.get("months");
                if (months > 0) {
                    if (months == 1) {
                        result.push(months + " Month");
                    } else {
                        result.push(months + " Months");
                    }
                }

                let days = totalDuration.get("days");
                if (days > 0) {
                    if (days == 1) {
                        result.push(days + " Day");
                    } else {
                        result.push(days + " Days");
                    }
                }

                let hours = totalDuration.get("hours");
                if (hours > 0) {
                    if (hours == 1) {
                        result.push(hours + " Hour");
                    } else {
                        result.push(hours + " Hours");
                    }
                }

                let minutes = totalDuration.get("minutes");
                if (minutes > 0) {
                    if (minutes == 1) {
                        result.push(minutes + " Minute");
                    } else {
                        result.push(minutes + " Minutes");
                    }
                }

                return result.join(" ");
            }
        },
        engineerDisplayText(param) {
            const _this = this;
            let display_name = new Array();
            if (
                _this.lodash.isEmpty(param) === false &&
                _this.lodash.isArray(param)
            ) {
                display_name.push(param[0].display_name);
                if (param.length - 1) {
                    const message = ` +${param.length - 1} more...`;
                    display_name.push(message);
                }
            }
            if (_this.lodash.isEmpty(display_name)) {
                return "Not assigned.";
            } else {
                return display_name.join(", ");
            }
        },
    },
};
</script>
<style>
.v-window {
    overflow: initial !important;
}
</style>

